import { Switch, useDisclosure } from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { IoIosSend } from "react-icons/io";
import { SelectNotificationModal } from "../Modals/SelectNotificationModal";
import { DateTime } from "luxon";
import NotificationStatus from "../Card/NotificationStatus";
import { userListContext } from "../../Pages/users/ListContext";
import { ProActivatationModal } from "../Modals/ProActivatationModal";

export const SingleUserJourneyList = ({ id, props, index, func }: any) => {
  const {
    _id,
    personal_information,
    //  { age, city, state, gender },
    matched_assessment_details,
    instantbookings,
    lead_level,
    bookings,
    assessments,
    createdAt,
    updatedAt,
    userchats,
    notifications,
    manoshala_pro: { is_active },
  } = props;
  // console.log(props);
  // console.log("personal_infomation", personal_information);
  const convertISO = (date: any) => {
    const dateTime = DateTime.fromISO(date, { zone: "utc" }).setZone(
      "Asia/Kolkata"
    );

    const formattedDate = dateTime.toFormat("dd LLL yy - hh:mm a");
    return formattedDate;
  };

  const [isEnabled, setIsEnabled] = useState(is_active);

  const { isallChecked } = useContext(userListContext);
  const [isChecked, setIsChecked] = useState(isallChecked);

  const [modal, setModal] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();

  const activatePro = (enabled: boolean) => {
    setIsEnabled(enabled);
  };

  const checkSingleBooking = () => {
    let isAnySingleBooking = false;
    for (let booking of bookings) {
      if (booking.subscription.session_count === "1") {
        isAnySingleBooking = true;
        break;
      }
    }
    return isAnySingleBooking;
  };
  const LeadLevel = (lead_level: number) => {
    let color;
    let text;

    switch (lead_level) {
      case 1:
        color = "#FF0000"; // Red
        text = "1";
        break;
      case 2:
        color = "#0000FF"; // Orange
        text = "2";
        break;
      case 3:
        color = "#A52A2A"; // Yellow
        text = "3";
        break;
      case 4:
        color = "#00FF00"; // Green
        text = "4";
        break;
      default:
        color = "#000000";
        text = "Unknown";
    }

    return (
      <div style={{ color, fontWeight: "bolder", fontSize: "16px" }}>
        {text}
      </div>
    );
  };

  useEffect(() => {
    setIsChecked(isallChecked);
    func(id, isallChecked);
  }, [isallChecked]);

  return (
    <tr>
      <td>
        <div className="edit-icon">
          <input
            type="checkbox"
            aria-label="Checkbox"
            checked={isChecked}
            onChange={(e) => {
              func(id, e.target.checked);
              setIsChecked(e.target.checked);
            }}
          />
        </div>
      </td>
      <td>{index + 1}</td>
      <td>{convertISO(updatedAt)}</td>
      <td>{convertISO(createdAt)}</td>
      <td>
        <Switch
          isChecked={isEnabled}
          isDisabled={isEnabled}
          onChange={(e) => {
            if (!is_active) {
              setModal("activateProModal");
              onOpen();
            }
          }}
        />
      </td>
      <td>{LeadLevel(lead_level)}</td>
      <td>
        {personal_information && personal_information.gender
          ? personal_information.gender
          : "Not known"}
      </td>
      <td>
        {personal_information && personal_information.age
          ? personal_information.age
          : "Not known"}
      </td>
      <td>
        {personal_information && personal_information.city
          ? personal_information.city
          : "Not known"}
        ,
        {personal_information && personal_information.state
          ? personal_information.state
          : ""}
      </td>
      <td>
        {matched_assessment_details.assessments.length > 0 ? (
          <span style={{ color: "green" }}>Yes</span>
        ) : (
          <span style={{ color: "red" }}>No</span>
        )}
      </td>
      <td>
        {userchats.length > 0 ? (
          <span style={{ color: "green" }}>Yes</span>
        ) : (
          <span style={{ color: "red" }}>No</span>
        )}
      </td>
      <td>
        {assessments.length > 0 ? (
          <span style={{ color: "green" }}>Yes</span>
        ) : (
          <span style={{ color: "red" }}>No</span>
        )}
      </td>
      <td>
        {instantbookings.length > 0 ? (
          <span style={{ color: "green" }}>Yes</span>
        ) : (
          <span style={{ color: "red" }}>No</span>
        )}
      </td>
      <td>
        {checkSingleBooking() ? (
          <span style={{ color: "green" }}>Yes</span>
        ) : (
          <span style={{ color: "red" }}>No</span>
        )}
      </td>
      <td>
        {lead_level == 4 ? (
          <span style={{ color: "green" }}>Yes</span>
        ) : (
          <span style={{ color: "red" }}>No</span>
        )}
      </td>
      <td>
        <NotificationStatus notifications={notifications.reverse() || []} />
      </td>
      <td>
        <div className="d-flex justify-content-around align-items-center">
          <div>
            <span title="App notification">
              <IoIosSend
                className="button-icon pointer"
                onClick={() => {
                  setModal("notificationModal");
                  onOpen();
                }}
              />
            </span>
          </div>
          <div>
            <span title="Whatsapp notification">
              <FaWhatsapp
                className="button-icon disabledButton"
                onClick={() => {
                  // setModal("subscriptionnotification");
                  // onOpen();
                }}
              />
            </span>
          </div>
        </div>
      </td>
      {modal === "notificationModal" && (
        <SelectNotificationModal
          isOpen={isOpen}
          onClose={onClose}
          category={""}
          ids={[_id]}
          // func={closeModal}
          // id={id}
        />
      )}
      {modal === "activateProModal" && (
        <ProActivatationModal
          isOpen={isOpen}
          onClose={onClose}
          func={activatePro}
          id={_id}
        />
      )}
    </tr>
  );
};
